import React from "react";
import { PageHeader } from "@finitless/shared/components";
import {
  MetricCardSkeleton,
  PopularItemsSkeleton,
  OrderRowSkeleton,
  CustomerSatisfactionSkeleton,
  FilterSkeleton,
} from "../../Skeletons";

/**
 * Centralized loading state component for OverviewPage
 * @param {Object} props - Component props
 * @param {Object} props.selectedBrand - Selected brand for header
 * @param {string} props.welcomeMessage - Welcome message to display
 * @param {number} props.cardCount - Number of loading cards to show (default: 6)
 */
const LoadingState = ({ selectedBrand, welcomeMessage, cardCount = 6 }) => {
  return (
    <div>
      <PageHeader title="Overview" selectedBrand={selectedBrand}>
        <p className="text-lg text-gray-300">{welcomeMessage}</p>
      </PageHeader>

      {/* Lapse Filter Skeleton */}
      <FilterSkeleton />

      {/* Metrics Grid */}
      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-4">
        {Array.from({ length: cardCount }).map((_, index) => (
          <MetricCardSkeleton key={index} />
        ))}
      </div>

      {/* Popular Items Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-1">
        <PopularItemsSkeleton titleWidth="w-48" itemCount={5} />
      </div>

      {/* Popular Categories Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-1">
        <PopularItemsSkeleton titleWidth="w-56" itemCount={4} />
      </div>

      {/* Recent Orders and Customer Satisfaction Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Recent Orders Skeleton */}
        <div className="rounded-lg border border-gray-800 bg-gray-900">
          <div className="border-b border-gray-800 p-6">
            <div className="flex items-center justify-between">
              <div className="h-6 w-32 animate-pulse rounded bg-gray-700"></div>
              <div className="h-4 w-16 animate-pulse rounded bg-gray-700"></div>
            </div>
          </div>
          <div className="divide-y divide-gray-800">
            {Array.from({ length: 5 }).map((_, index) => (
              <OrderRowSkeleton key={index} />
            ))}
          </div>
        </div>

        {/* Customer Satisfaction Skeleton */}
        <CustomerSatisfactionSkeleton />
      </div>
    </div>
  );
};

export { LoadingState };
